// extracted by mini-css-extract-plugin
export var grey = "LogoSection-module--grey--3P7WK";
export var white = "LogoSection-module--white--3bPR2";
export var darkBlue = "LogoSection-module--dark-blue--2eQ5G";
export var logos = "LogoSection-module--logos--3ttO_";
export var logoCta = "LogoSection-module--logo-cta--gQ38C";
export var logoGrid = "LogoSection-module--logo-grid--1wmCE";
export var competitivePage = "LogoSection-module--competitive-page--2c_TE";
export var adjust = "LogoSection-module--adjust--Lxvz9";